import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type StoreService from '@ember-data/store';
import MailerTemplateModel from 'garaje/models/mailer-template';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { hash } from 'rsvp';

import type SettingsEmailTemplatesShowController from '../controller';
import type { SettingsEmailTemplatesShowRouteModel } from '../route';

const { TRIGGER_NAME_MAPPING } = MailerTemplateModel;

export default class SettingsEmailTemplatesShowCustomRouteParams extends Route {
  declare controller: SettingsEmailTemplatesShowController;
  controllerName = 'visitors.settings.email-templates.show';

  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;
  @service declare store: StoreService;

  get allowUIHooksInCustomContent(): boolean {
    return this.featureFlags.isEnabled('hooks-custom-content-in-email-template');
  }

  async model({ mailer_template_id }: { mailer_template_id: string }): Promise<SettingsEmailTemplatesShowRouteModel> {
    const { allowUIHooksInCustomContent } = this;
    const parentRouteModel = <SettingsEmailTemplatesShowRouteModel>(
      this.modelFor('visitors.settings.email-templates.show')
    );
    const mailerTemplate = await this.store.findRecord('mailer-template', mailer_template_id, {
      reload: true,
    });

    const uiHooks = allowUIHooksInCustomContent
      ? this.store.query('ui-hook', {
          location: parentRouteModel.currentLocation.id,
          triggerName: TRIGGER_NAME_MAPPING[<keyof typeof TRIGGER_NAME_MAPPING>mailerTemplate.identifier],
        })
      : undefined;

    const { mailerTemplateSections } = mailerTemplate;

    return hash({
      ...parentRouteModel,
      ...{
        mailerTemplate,
        mailerTemplateSections,
        uiHooks,
      },
    });
  }
}
